module.exports = __webpack_public_path__ + "static/rocket-2e5ab0cc73d14eccae10b6bc097a5900.svg";